import React from "react";
import WorkspaceHub from "../template/WorkspaceHub";

export default () => {
  return <WorkspaceHub />;
};
